export const FEATURES = [
  {
    icon: "userGroup",
    title: "مدیریت باشگاه",
    desc: "هر باشگاه با اکانت اختصاصی، بازیکنان خود را ثبت و مدیریت می‌کند.",
  },
  {
    icon: "trophy",
    title: "مسابقات و نتایج",
    desc: "تعریف تورنمنت، ثبت‌نام تیم‌ها، برنامه‌ی بازی‌ها و ثبت نتایج.",
  },
  {
    icon: "news",
    title: "اخبار و رویدادها",
    desc: "انتشار مستقیم اخبار، رویدادهای هیئت و اطلاعیه‌های رسمی.",
  },
  {
    icon: "award",
    title: "پروفایل بازیکنان",
    desc: "مشخصات کامل، عکس، بیمه و مدارک - از نونهال تا بزرگسال.",
  },
  {
    icon: "calendar",
    title: "تقویم و برنامه",
    desc: "برنامه‌های آموزشی، دوره‌های مربیگری و رویدادهای پیش رو.",
  },
  {
    icon: "shield",
    title: "کمیته‌های تخصصی",
    desc: "داوران، فنی، پزشکی، بانوان، فوتسال، انضباطی و اخلاق.",
  },
];

